<template>
  <div>
    <div class="footer-container">
      <div class="footer-facebook">
        <span class="enter-btn" @click="goPage('Facebook')">\ 分享出去 /</span>
        <img class="enter-btn" src="../assets/img/icon-facebook.svg" alt=""  @click="goPage('Facebook')"/>
      </div>
      <div class="footer-body">
        <div class="subscript-box" @click="goPage('Subscript')">
          <el-input class="email-input" placeholder="輸入e-mail">
            <template slot="append">訂閱</template>
          </el-input>
        </div>
        <el-row class="menu-container">
          <span class="enter-btn" @click="goPage('About')">關於我們</span>
          <el-divider direction="vertical"></el-divider>
          <span class="enter-btn" @click="goPage('News')">最新消息</span>
          <el-divider direction="vertical"></el-divider>
          <span class="enter-btn" @click="goPage('ResourceIndex')">教育資源</span>
          <el-divider direction="vertical"></el-divider>
          <span class="enter-btn" @click="goPage('Thanks')">感謝名單</span>
          <el-divider direction="vertical"></el-divider>
          <span class="enter-btn" @click="goPage('Movie')">線上電影院</span>
        </el-row>
      </div>
      <el-divider></el-divider>
      <div class="footer-contact">
        <span>copyright © 2022 縫猴子宇宙 All rights reserved</span>
      </div>
    </div>
    <div class="footer-container mobile-footer-container">
      <div class="footer-body">
        <div class="footer-mobile-fb-email">
          <div class="footer-facebook" @click="goPage('Facebook')">
            <span>\ 分享出去 /</span>
            <img src="../assets/img/icon-facebook-white.svg" alt="" />
          </div>
          <div class="footer-email subscript-box" @click="goPage('Subscript')">
            <span>訂閱最新消息</span>
            <el-input class="email-input" placeholder="輸入e-mail">
              <template slot="append">訂閱</template>
            </el-input>
          </div>
        </div>
        <div class="menu-container">
          <el-row>
            <div class="enter-btn" @click="goPage('About')">關於我們</div>
            <div class="enter-btn" @click="goPage('News')">最新消息</div>
            <div class="enter-btn" @click="goPage('ResourceIndex')">教育資源</div>
            <span class="enter-btn" @click="goPage('Movie')">線上電影院</span>
          </el-row>
          <el-row>
            <div class="enter-btn" @click="goPage('Thanks')">感謝名單</div>
          </el-row>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="footer-contact">
        <span>copyright © 2022 縫猴子宇宙 All rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "FooterComponent",
  computed: {
  },
  methods: {
    goPage(page) {
      console.log('go page : ' + page)
      if (page === 'Facebook') {
        this.$12nightsConfirm({
          title: "您將前往前往外部連結",
          message: "https://www.facebook.com/twelvenights/"
        }).then(() => {
          window.open("https://www.facebook.com/twelvenights/", '_blank')
        })
      } else if (page === 'Movie') {
        this.$12nightsConfirm({
          title: "您將前往前往外部連結",
          message: "https://youtu.be/PfZdrRygmec"
        }).then(() => {
          window.open("https://youtu.be/PfZdrRygmec", '_blank')
        })
      } else if (page === 'Subscript') {
        if (this.$route.name !== "UserInfo" && this.$route.name !== "Login") {
          if (this.$store.getters.token) {
            this.$router.push({
              name: "UserInfo"
            });
          } else {
            this.$router.push({
              name: "Login"
            });
          }
        }
      } else if (this.$route.name !== page) {
        this.$router.push({
          name: page
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
</style>
